import {CustomerCharacteristicAttribute} from './customer-characteristic-attribute.model';
export class CustomerCharacteristic {
    public id: number;
    public customerNumberID: number;
    public customerCharacteristicTypeId: number;
    public attributes: CustomerCharacteristicAttribute[];
    public effectiveDate: any;
    public endDate: any;

    public updatedBy: string;
    public updatedDate: any;

    public viewId: number;
    public characteristicType: string;
}
